"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title"],
  _excluded2 = ["aria-hidden"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.71112 4.00194L1.29501 5.41426L7.98512 12.1223L14.7092 5.41615L13.2969 4.00005L7.9889 9.29388L2.71112 4.00194Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16"
};
var sizesToPathSizes = {
  "16": "16"
};
var sizes = ['16'];
var IconAccordionCaretDown = function IconAccordionCaretDown(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '16' : _ref$size,
    title = _ref.title,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _props$ariaHidden = props["aria-hidden"],
    ariaHidden = _props$ariaHidden === void 0 ? 'true' : _props$ariaHidden,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded2);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '16';
  var finalAriaHidden = (title ? false : ariaHidden).toString();
  var finalTitle = finalAriaHidden === 'false' ? title || 'Accordion Caret Down' : null;
  if (title && (ariaHidden === true || ariaHidden === 'true') && process.env.NODE_ENV !== 'production') {
    console.warn('Passing a custom title will set the aria-hidden attribute to false within IconAccordionCaretDown. Consider passing aria-hidden="false" explicitly to IconAccordionCaretDown for compatibility with future versions.');
  }
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: finalTitle,
    "aria-hidden": finalAriaHidden
  }, rest, {
    iconClass: "AccordionCaretDown"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconAccordionCaretDown.sizes = [16];
IconAccordionCaretDown.propTypes = {
  /** Available sizes: 16. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = exports.default = IconAccordionCaretDown;